import React, { forwardRef } from "react";
import { useLogout } from "react-admin";
import { MenuItem } from "@mui/material";
import ExitIcon from "@mui/icons-material/PowerSettingsNew";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

const MyLogoutButton = forwardRef((props, ref) => {
  const logout = useLogout();
  const handleClick = () => logout();
  return (
    <MenuItem onClick={handleClick} ref={ref}>
      <ListItemIcon>
        <ExitIcon />
      </ListItemIcon>
      <ListItemText>{props.label}</ListItemText>
    </MenuItem>
  );
});

export default MyLogoutButton;
